import { render, staticRenderFns } from "./UnsubscribedUsers.vue?vue&type=template&id=dfb54186&"
import script from "./UnsubscribedUsers.vue?vue&type=script&lang=js&"
export * from "./UnsubscribedUsers.vue?vue&type=script&lang=js&"
import style0 from "./UnsubscribedUsers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports